module.exports = __webpack_public_path__ + "resources/img/logo_toast_color.6908a530eef35f6350fae06a7792fcbd.svg";